import { Theme } from '@mui/material/styles'
import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles<{ columnDivision: number }>()(
  (theme: Theme, { columnDivision }) => ({
    root: {
      padding: theme.spacing(3, 4),
      width: '100%',
      borderRadius: theme.spacing(0.5),
      boxSizing: 'border-box',
    },
    rootWithBorder: {
      border: `1px solid ${theme.palette.dividerV2.main}`,
    },
    rootNoPadding: {
      padding: 0,
    },
    elementsGap: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(3),
    },
    columnHeaderSection: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
    },
    installmentsContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(3),
      width: '100%',
    },
    sectionText: {
      fontSize: `${theme.spacing(1.75)} !important`,
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: `${theme.spacing(2.5)} !important`,
      letterSpacing: theme.spacing(0.03125),
      color: theme.palette.labraText.description,
      fontFamily: theme.typography.fontFamily,
      textAlign: 'left',
    },
    textContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: theme.spacing(1),
      width: '100%',
    },
    resourceRow: {
      display: 'flex',
      justifyContent: 'flex-start',
      gap: theme.spacing(4),
      width: '100%',
    },
    resourcesContainer: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      gap: theme.spacing(4),
      width: '100%',
    },
    resourcesAlignStart: {
      alignItems: 'flex-start',
    },
    installmentField: {
      width: '100%',
      '& .MuiOutlinedInput-root': {
        minHeight: theme.spacing(5.5),
        height: theme.spacing(5.5),
        boxSizing: 'border-box',
      },
      '& .MuiPickersInputBase-root, & .MuiPickersOutlinedInput-root': {
        minHeight: theme.spacing(5.5),
        height: theme.spacing(5.5),
        boxSizing: 'border-box',
      },
    },
    resouceField: {
      width: '49%',
    },
    dayOfMonthField: {
      width: '49%',
      maxWidth: theme.spacing(40),
    },
    trashIcon: {
      color: theme.palette.labraIcon.main,
      cursor: 'pointer',
      flexShrink: 0,
      width: theme.spacing(2.25),
      display: 'flex',
      alignItems: 'center',
    },
    buttonSubText: {
      color: theme.palette.textField.main,
      fontSize: theme.spacing(1.75),
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: theme.spacing(2.5),
      letterSpacing: theme.spacing(0.03125),
    },
    widthButton: {
      width: 'fit-content',
      marginBottom: theme.spacing(1),
    },
    totalText: {
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.spacing(2),
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: theme.spacing(3),
      letterSpacing: theme.spacing(0.01875),
      color: theme.palette.textField.dark,
      marginTop: theme.spacing(1),
    },
    totalTextHeading: {
      fontSize: `${theme.spacing(1.5)} !important`,
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: `${theme.spacing(2)} !important`,
      letterSpacing: theme.spacing(0.03125),
      color: theme.palette.labraText.description,
      fontFamily: theme.typography.fontFamily,
      textAlign: 'left',
    },
    border: {
      borderBottom: `1px solid ${theme.palette.dividerV2.main}`,
      width: '100%',
      borderRadius: theme.spacing(0.5),
      boxSizing: 'border-box',
    },
    titleWraper: {
      display: 'flex',
      gap: theme.spacing(4),
      paddingBottom: theme.spacing(1.25),
    },
    lowerWrapper: {
      marginTop: theme.spacing(0.5),
    },
    metricsRow: {
      display: 'flex',
      gap: theme.spacing(6),
      flexWrap: 'wrap',
    },
    metricItem: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1),
    },
    sectionHeading: {
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.spacing(2),
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: theme.spacing(3),
      letterSpacing: theme.spacing(0.01875),
      marginBottom: theme.spacing(-3),
    },
    generateBtn: {
      margin: theme.spacing(-2, 0, -1, 0),
      height: theme.spacing(5),
    },
    installmentsWrapper: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(3),
      width: '100%',
    },
    currency: {
      color: theme.palette.labraText.description,
      lineHeight: theme.spacing(2.5),
      fontSize: theme.spacing(1.75),
    },
    price: {
      display: 'flex',
      alignItems: 'baseline',
      fontSize: theme.spacing(2),
      lineHeight: theme.spacing(3),
      marginTop: theme.spacing(-1),
    },
    fixedTcvWrapper: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      justifyContent: 'center',
    },
    radioSelection: {
      width: 'fit-content',
    },
    columnTextValue: {
      fontSize: theme.spacing(1.75),
      fontWeight: 400,
      lineHeight: theme.spacing(2.5),
      color: theme.palette.textField.dark,
      display: 'flex',
      alignItems: 'center',
      height: '100%',
    },
    textAlignLeft: {
      textAlign: 'left',
    },
    textAlignRight: {
      textAlign: 'right',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'end',
    },
    columnFlex: {
      width: `${columnDivision}%`,
    },
    trashIconSize: {
      width: theme.spacing(2.25),
      height: theme.spacing(2.5),
    },
    trashHeaderSpacer: {
      flexShrink: 0,
      width: theme.spacing(2.25),
    },
    percentSumError: {
      fontFamily: theme.typography.caption.fontFamily,
      fontSize: theme.typography.caption.fontSize,
      fontWeight: theme.typography.caption.fontWeight,
      lineHeight: theme.typography.caption.lineHeight,
      letterSpacing: theme.typography.caption.letterSpacing,
      color: theme.palette.error.main,
      marginTop: theme.spacing(0.5),
    },
  })
)
